export default __webpack_public_path__ + "dc2fc58c3fc5994ccb10f251c9f23f31.png";